import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StoreModule} from '@ngrx/store';
import * as fromTheme from './store/reducers/theme.reducer';
import { SidebarHeaderComponent } from './components/sidebar-header/sidebar-header.component';
import { SidebarNavComponent } from './components/sidebar-nav/sidebar-nav.component';
import { SidebarHeaderLogoComponent } from './components/sidebar-header-logo/sidebar-header-logo.component';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
    SidebarHeaderComponent,
    SidebarNavComponent,
    SidebarHeaderLogoComponent,

  ],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromTheme.themeFeatureKey, fromTheme.reducer),
        RouterModule,
    ],
    exports: [
        SidebarHeaderComponent,
        SidebarNavComponent,
    ]
})
export class ThemeModule { }
